import React from 'react'
import * as SurveyJS from 'survey-react'

import FileUploadWrapper from './fileUploadWrapper'

const FileUploadWidget = {
  name: 'fileuploadwidget',
  title: 'fileuploadwidget',
  iconName: 'icon-default',
  widgetisLoaded: function() {
    return true
  },
  isFit: function(question) {
    switch (question.name) {
      case 'Xplor_ChildCourtOrders':
        return true
      case 'Xplor_ChildHealthRecord':
        return true
      case 'Xplor_ChildImmunisedRecord':
        return true
      case 'Xplor_ChildAnaphylaxisPlan':
        return true
      case 'Xplor_ChildAsthma':
        return true
      case 'Xplor_ChildBirthCert':
        return true
      case 'Xplor_ChildChildPhoto':
        return true
      case 'Xplor_PCPhoto':
        return true
      case 'Xplor_ACPhoto':
        return true
      case 'Xplor_ChildParentingOrders':
        return true
      default:
        return false
    }
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('fileuploadwidget', [], null, 'text')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <FileUploadWrapper question={question} />
  }
}

export default FileUploadWidget
